// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Box, useSystem } from 'react-system';
import { Marked } from '../../controls/marked';
import { useLocale } from '../../hooks/locale';
import { useTheme } from '../../theme';

import type { DevelopmentDescription_development$key } from './__generated__/DevelopmentDescription_development.graphql';

type Props = {|
  development: DevelopmentDescription_development$key,
|};

export const DevelopmentDescription = (props: Props): React.Node => {
  const { text } = useTheme();
  const { media } = useSystem();
  const { t } = useLocale();
  const development = useFragment(
    graphql`
      fragment DevelopmentDescription_development on DevelopmentProduct {
        description
      }
    `,
    props.development,
  );
  if (development.description == null) {
    return null;
  }
  return (
    <>
      <Box py={3} css={media([text.h6, text.h5])}>
        {t('description')}
      </Box>
      <Box css={text.body1}>
        <Marked>{development.description ?? ''}</Marked>
      </Box>
    </>
  );
};
